module.exports = "https://static.moomoo.com/components/common-redpacket/images/img_5.77403a5762.jpg";